
    <div class="sidebar ">
   
    <!-- Navigation Items -->
    <div class="nav-tabs nav-box-shadow">
         <div (click)="closeSidebar()" class="">
        <i class="ri-grid-fill  cursor-pointer"></i>
    </div>
        <ng-container *ngIf="employee_details?.designation === 'Caratred Supervisor'">
            <div routerLink="/home/company" routerLinkActive="active" class="nav-item" placement="end"
               (click)="closeSidebar()">
                <p class="m-0 d-flex align-items-center">
                    <i class="ri-building-line"></i>
                    <span>Company</span>
                </p>
            </div>
            <div routerLink="/home/modules" routerLinkActive="active" class="nav-item" placement="end"
                (click)="closeSidebar()">
                <p class="m-0 d-flex align-items-center ">
                    <i class="ri-layout-grid-2-line px-2"></i>
                    <span>Modules</span>
                </p>
            </div>
        </ng-container>

        <ng-container *ngIf="employee_details?.designation !== 'Caratred Supervisor'">
            <div routerLink="/home/products" routerLinkActive="active" class="nav-item products-tab" placement="end"
                (click)="closeSidebar()">
                <p class="m-0 d-flex align-items-center ">
                    <i class="ri-layout-grid-2-line px-2"></i>
                    <span>Products</span>
                </p>
            </div>
        </ng-container>

        <div routerLink="/home/users" routerLinkActive="active" class="nav-item" placement="end"
            (click)="closeSidebar()">
            <p class="m-0 d-flex align-items-center ">
                <i class="ri-user-3-line px-2"></i>
                <span>Employees</span>
            </p>
        </div>

        <div routerLink="/home/roles" routerLinkActive="active" class="nav-item" placement="end"
           (click)="closeSidebar()">
            <p class="m-0 d-flex align-items-center ">
                <i class="ri-id-card-fill px-2"></i>
                <span>Roles</span>
            </p>
        </div>

        <div routerLink="/home/department" routerLinkActive="active" class="nav-item" placement="end"
           (click)="closeSidebar()">
            <p class="m-0 d-flex align-items-center ">
                <i class="ri-git-merge-line px-2"></i>
                <span>Department</span>
            </p>
        </div>

        <div routerLink="/home/permissions" routerLinkActive="active" class="nav-item" placement="end"
            (click)="closeSidebar()">
            <p class="m-0 d-flex align-items-center ">
                <i class="ri-key-fill px-2"></i>
                <span>Permissions</span>
            </p>
        </div>

        <div routerLink="/home/settings" routerLinkActive="active" class="nav-item products-tab" placement="end"
             (click)="closeSidebar()">
            <p class="m-0 d-flex align-items-center ">
                <i class="ri-settings-4-line px-2"></i>
                <span>Settings</span>
            </p>
        </div>

        <!-- Collapse toggle -->
        <!-- <div class="collapse-btn text-center " (click)="toggleSidebar()">
        <i [class]="isCollapsed ? 'ri-menu-unfold-line' : 'ri-menu-fold-line'"></i>
      </div> -->
    </div>
    <!-- Collapse Button -->
    <!-- <div class="collapse-btn text-center py-3 " (click)="toggleSidebar()">
      <i [class]="isCollapsed ? 'ri-menu-unfold-line' : 'ri-menu-fold-line'"></i>
    </div> -->
</div>



